// Unknown price = not free and no price declared (bulk "Sin precio"). Places (permanent) show nothing.
export const isPriceUnknown = (event) =>
  !!event && !event.is_permanent && !event.is_free && (event.price === null || event.price === undefined);

export const PRICE_TBC_LABEL = 'Precio por confirmar';
